<template>
  <div class="route-details-controls">
    <button v-if="isSavable"
            class="btn"
            :disabled="!route.isValid || !hasChanges"
            @click="save"
    >
      <app-icon icon="save"/>

      {{ $t('routeBuilder.save') }}
    </button>

    <button v-if="isEditable"
            class="btn"
            @click="edit"
    >
      <app-icon icon="pencil"/>

      {{ $t('routeBuilder.edit') }}
    </button>

    <button v-if="isCancelable"
            class="btn"
            @click="cancel"
    >
      <app-icon icon="close"/>

      {{ $t('routeBuilder.cancel') }}
    </button>

    <button v-if="isResettable"
            class="btn"
            @click="reset"
    >
      <app-icon icon="rollback"/>

      {{ $t('routeBuilder.reset') }}
    </button>

    <button v-if="isClearable"
            class="btn"
            @click="clear"
    >
      <app-icon icon="trash-can"/>

      {{ $t('routeBuilder.clear') }}
    </button>

    <button v-if="isPDFable"
            class="btn route-details-controls__pdf-button"
            :disabled="isPdfProcessing"
            @click="generatePdf"
    >
      <app-icon icon="pdf"/>
    </button>
  </div>
</template>

<script>
import Route from "@/models/Route";
import generateRoutePdf from "@/helpers/generateRoutePdf";
import { mapActions } from "vuex";

export default {
  name: "RouteDetailsControls",
  props: {
    route: {
      type: Route,
      required: true
    }
  },
  data() {
    return  {
      isPdfProcessing: false
    }
  },
  computed: {
    routeId() {
      return this.route.id
    },

    hasChanges() {
      if (!this.route.savedEditingCoordinatesIds) {
        return false
      } else {
        return this.route.savedEditingCoordinatesIds.join(',') !== this.route.coordinatesIds.join(',')
      }
    },

    isCancelable() {
      return this.route.isEditing
    },
    isResettable() {
      return !this.route.isEditing && this.route.isCustom
    },
    isClearable() {
      return !this.route.isEditing && this.route.isNew
    },
    isSavable() {
      return this.route.isEditing
    },
    isPDFable() {
      return this.route.isValid && !this.route.isEditing
    },
    isEditable() {
      return !this.route.isEditing
    }
  },
  methods: {
    clear() {
      this.removeRoute(this.routeId)
    },
    cancel() {
      this.cancelRouteEditing(this.routeId)
    },
    reset() {
      this.resetRouteToApi(this.routeId)
    },
    save() {
      this.saveRouteEditing(this.routeId)
    },
    generatePdf() {
      this.isPdfProcessing = true

      generateRoutePdf(this.route)
        .finally(() => {
          this.isPdfProcessing = false
        })
    },
    edit() {
      this.startRouteEditing(this.routeId)
    },

    ...mapActions('Routes', [
      'removeRoute',
      'resetRouteToApi',
      'startRouteEditing',
      'saveRouteEditing',
      'cancelRouteEditing'
    ])
  }
}
</script>

<style lang="scss">
.route-details-controls {
  display: flex;
  padding-top: 13px;

  .btn {
    margin-top: 10px;

    &:not(:last-child) {
      margin-right: 10px;
    }
  }

  &__pdf-button {
    margin-left: auto;

    .app-icon {
      margin-right: 0 !important;
    }
  }
}
</style>
